import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatFormFieldModule } from '@angular/material/form-field';
import { FieldResource } from "../../core/modules/openapi";

@Component({
  selector: "app-label",
  imports: [MatFormFieldModule],
  template: `
    <div class="app-label">
      <h6 class="mat-form-field--inline">
        <mat-label>{{ field.displayName }}</mat-label>
      </h6>
    </div>
  `,
  standalone: true,
  styleUrls: ['./label.component.css']
})
export class LabelComponent implements OnInit {
  field: FieldResource;
  group: FormGroup;
  constructor() {}
  ngOnInit() {}
}
